import { OrNull } from '../interfaces';

export interface AppraisalClaimSolveModel {
  solutionDescription: OrNull<string>;
}
